var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14ZM24.4 14C24.4 8.25624 19.7438 3.6 14 3.6C8.25624 3.6 3.6 8.25624 3.6 14C3.6 19.7438 8.25624 24.4 14 24.4C19.7438 24.4 24.4 19.7438 24.4 14ZM13.2 20.2V18.8C13.2 18.3582 13.5582 18 14 18C14.4418 18 14.8 18.3582 14.8 18.8V20.2C14.8 20.6418 14.4418 21 14 21C13.5582 21 13.2 20.6418 13.2 20.2ZM13.2 16.2V7.8C13.2 7.35817 13.5582 7 14 7C14.4418 7 14.8 7.35817 14.8 7.8V16.2C14.8 16.6418 14.4418 17 14 17C13.5582 17 13.2 16.6418 13.2 16.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedWarning);
export default __webpack_public_path__ + "static/media/rounded-warning.de1be237.svg";
export { ForwardRef as ReactComponent };